import { registerComponent, registerComponentEagerly } from "react_mount"

// Public content pages use the content bundle instead of application, so both
// entrypoints import this shared registration module.
registerComponent(
  "podcast-listen-and-subscribe",
  () => import("containers/PodcastListenAndSubscribe"),
)

// Loaded on demand by comments_actions_view.js, only for editors with manage_comments
export const loadContentCommentManager = () =>
  import("components/Editorial/ContentCommentManager").then(({ default: component }) =>
    registerComponentEagerly("content-comment-manager", component),
  )
